module.exports = __webpack_public_path__ + "media/images/thumbs/physanims/a5-9-782a71fa610a4c2006030560d763b969.jpg";